import styled from "styled-components";
import { textSize, text_size } from "@/app/utils/MixinSize";
import { Grid } from "@mui/material";
import { useLanguage } from "@/app/utils/LanguageContext";
import "@/app/style/raceInfo.scss"; 

export type RaceSelectorData = {
    [venueCode: string]: { races: number[] };
}

type RaceSelectorProps = {
    type: string;
    selectedRaceNo: number;
    selectedVenueCode: string;
    handleSelectRace: (selectedRaceNo: number, venueCode?: string) => void;
    data?: RaceSelectorData;
    enableAllBtn?: boolean;
}

const HeaderItem = styled.div<{ selected?: boolean; disabled?: boolean }>`
  border-radius: 50%;
  margin-right: 8px;
  height: 36px;
  min-height: 36px;
  max-height: 36px;
  width: 36px;
  min-width: 36px;
  max-width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ disabled }) => (!disabled ? "cursor: pointer;" : "")}
  background-color: ${({ selected }) => !selected ? "rgba(97, 118, 160, 1)" : "rgba(23, 62, 150, 1)"};
  p {
    ${text_size(15)}
    font-weight: 500;
    line-height: 20.43px;
    text-align: center;
    color: white;
  }
`;

const StickyItem = styled.div`
  position: sticky; 
  margin-left: -8px;
  left: -8px;
  background: var(--palette-grey-100);
  border-right: 1px solid #979797;
  margin-right: 18px;
  padding-right: 8px;
  >div {
    margin-left: 8px;
  }
`;

export default function RaceSelector(props: RaceSelectorProps) {
    const { handleSelectRace, type: displayType, selectedRaceNo, selectedVenueCode, data } = props;
    const { state: lang } = useLanguage();
    const { t } = lang;
    return (
        <Grid container className={`raceSelectorContainer${displayType === "pc" ? " pc" : " mobile"}`}>
            {
                data && Object.keys(data).map((venue: string, idx: number)=>(
                <Grid key={idx} item xs={12} sx={{display: 'flex', ...(displayType==="pc"&&{justifyContent: 'end'}), ...(idx!==0&&{marginTop: '12px'})}}>
                    <StickyItem>
                        <HeaderItem id="venue_code" selected onClick={() => props.enableAllBtn && handleSelectRace(-1, venue)}>
                            <p>{venue || "S1"}</p>
                        </HeaderItem>
                    </StickyItem>
                    {props.enableAllBtn ? 
                        <HeaderItem
                            key={"All"}
                            id={`raceSelect_${venue}_all`}
                            selected={venue===selectedVenueCode&&selectedRaceNo===-1}
                            onClick={() => handleSelectRace(-1, venue)}
                        >
                            <p>{t("result_all")}</p>
                        </HeaderItem> : null}
                    {data[venue]?.races?.map((no: number, idx: number) => (
                        <HeaderItem
                            key={idx}
                            id={`raceSelect_no_${venue}_${no}`}
                            selected={venue===selectedVenueCode&&selectedRaceNo===no}
                            disabled={false}
                            onClick={() => (handleSelectRace(no, venue))}
                            >
                            <p>{no}</p>
                        </HeaderItem>
                    ))}
                </Grid>
                ))
            }
        </Grid>
    )
}